export const NAVIGATION = {
  my_casino: {
    text: 'navigation.my_casino',
    icon: 'icon-navigation-home',
    url: '/casino',
  },
  all_games: {
    text: 'navigation.all_games',
    url: '/casino/all-games',
  },
  bingo: {
    text: 'navigation.bingo',
    icon: 'icon-games-bingo',
    url: '/casino/bingo',
  },
  tournament: {
    text: 'navigation.tournaments',
    icon: 'icon-games-trophy',
    url: '/casino/tournaments',
  },
  virtual: {
    text: 'navigation.virtual',
    icon: 'icon-games-virtuals',
    url: '/casino/virtual',
  },
  search: {
    text: 'navigation.search',
    icon: 'icon-navigation-search',
    url: '/casino/search',
  },
  jackpots: {
    text: 'navigation.jackpots',
    icon: 'icon-games-jackpot-hub',
    url: '/casino/jackpots',
  },
  providers: {
    text: 'navigation.providers',
    url: '/casino/providers',
  },
  promotions: {
    text: 'navigation.promo',
    icon: 'icon-commerce-gift',
    url: '/casino/promotions',
  },
  promo: {
    text: 'navigation.game',
    url: '/promo',
  },
  registration: {
    text: 'navigation.registration',
    url: '/registration',
  },
  game: {
    text: 'navigation.game',
    url: '/game',
  },
  login: {
    text: 'navigation.login',
    url: '/login',
  },
  account: {
    text: 'navigation.account',
    icon: 'icon-human-user',
    url: '/account',
  },
  wallet: {
    text: 'navigation.wallet',
    icon: 'icon-commerce-wallet',
    url: '/account/wallet',
  },
  profile: {
    text: 'navigation.profile',
    icon: 'icon-human-user-id',
    url: '/account/profile',
  },
  history: {
    text: 'navigation.history',
    icon: 'icon-commerce-transactions',
    url: '/account/history',
  },
  bonuses: {
    text: 'navigation.bonus',
    icon: 'icon-commerce-bonus',
    url: '/account/bonuses',
  },
  favourites: {
    text: 'navigation.favorites',
    icon: 'icon-toggle-favorite-filled',
    url: '/account/favorites',
  },
  empty: {
    text: 'navigation.not_found',
    url: '/404',
  }
}

export const USER_VERIFY = {
  0: 'not',
  1: 'verification',
  2: 'rejected',
  3: 'verified',
}

export const VOUCHER_STATUS = {
  0: 'new',
  1: 'paid',
  2: 'expired',
  3: 'cancelled'
}
